import apiClient from '../../../services/apiClient';

export default {
	namespaced: true,
	state: {
		initialized: false,
		pools: [],
		totalPools: 0,
		currentPage: 1,
		pageSize: 10,
		search: '',
		loading: false,
	},
	getters: {
		pools(state) {
			return state.pools;
		},
		totalPools(state) {
			return state.totalPools;
		},
		currentPage(state) {
			return state.currentPage;
		},
		pageSize(state) {
			return state.pageSize;
		},
		search(state) {
			return state.search;
		},
		loading(state) {
			return state.loading;
		},
	},
	mutations: {
		SET_POOLS(state, pools) {
			state.pools = pools;
		},
		SET_TOTAL_POOLS(state, total) {
			state.totalPools = total;
		},
		SET_CURRENT_PAGE(state, page) {
			state.currentPage = page;
		},
		SET_PAGE_SIZE(state, size) {
			state.pageSize = size;
		},
		SET_SEARCH(state, search) {
			state.search = search;
		},
		SET_LOADING(state, loading) {
			state.loading = loading;
		},
		ADD_POOL(state, pool) {
			state.pools.unshift(pool);
			state.totalPools++;
		},
		UPDATE_POOL(state, updatedPool) {
			const index = state.pools.findIndex(p => p.id === updatedPool.id);
			if (index !== -1) {
				state.pools.splice(index, 1, updatedPool);
			}
		},
		REMOVE_POOL(state, poolId) {
			state.pools = state.pools.filter(p => p.id !== poolId);
			state.totalPools--;
		},
		CLEAR_STORE(state) {
			state.pools = [];
			state.totalPools = 0;
			state.currentPage = 1;
			state.pageSize = 10;
			state.search = '';
			state.loading = false;
		}
	},
	actions: {
		async getPools({commit, state}) {
			commit('SET_LOADING', true);
			try {
				await apiClient.get('stockpools/list', {
					params: {
						page: state.currentPage,
						page_size: state.pageSize,
						search: state.search
					}
				}).then(res => {
					commit('SET_POOLS', res.data.pools || []);
					commit('SET_TOTAL_POOLS', res.data.totalPools || 0);
				}).catch(err => {
					commit('SET_POOLS', []);
				});
			} finally {
				commit('SET_LOADING', false);
			}
		},

		async createPool({commit}, poolData) {
			return new Promise((resolve, reject) => {
				apiClient.post('stockpools/create', poolData).then(res => {
					commit('ADD_POOL', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				});
			});
		},

		async updatePool({commit}, {poolId, poolData}) {
			return new Promise((resolve, reject) => {
				apiClient.put(`stockpools/update/${poolId}`, poolData).then(res => {
					commit('UPDATE_POOL', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				});
			});
		},

		async deletePool({commit}, poolId) {
			return new Promise((resolve, reject) => {
				apiClient.delete(`stockpools/delete/${poolId}`).then(res => {
					commit('REMOVE_POOL', poolId);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				});
			});
		},

		setPage({commit}, page) {
			commit('SET_CURRENT_PAGE', page);
		},

		setPageSize({commit}, size) {
			commit('SET_PAGE_SIZE', size);
		},

		setSearch({commit, dispatch}, search) {
			commit('SET_SEARCH', search);
			commit('SET_CURRENT_PAGE', 1);
			dispatch('getPools');
		},

		async clear({commit}) {
			commit('CLEAR_STORE');
		}
	}
}
